// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3mgDs","title":"Info_title__2MCoJ","selects":"Info_selects__2_jGj","requiredAsterisk":"Info_requiredAsterisk__2mPDe"};